// extracted by mini-css-extract-plugin
export default {"wrapper":"Y5oEhJ74qgexZYBQEdL0yQ==","video":"BPtGzrWBPSvyWf2+4pPyig==","fallback":"nred9jNE7HjpPbaNvkaQ9g==","overlay":"Eq5VRfc4lx7pYPwGTRELXg=="};